import { render } from "./Spinner.vue?vue&type=template&id=53aea7ce&ts=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=53aea7ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Widgets/Spinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53aea7ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53aea7ce', __exports__)) {
    api.reload('53aea7ce', __exports__)
  }
  
  module.hot.accept("./Spinner.vue?vue&type=template&id=53aea7ce&ts=true", () => {
    api.rerender('53aea7ce', render)
  })

}


export default __exports__